export default __webpack_public_path__ + "static/media/excel.bbff2c3d.png";